export const validateHexColor = (hexCode?: string) => {
  const isHexCodeValid = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(
    hexCode ? hexCode : '',
  );

  return isHexCodeValid;
};
